(() => {
  if (window.kwNativeNavigationSearch) return;
  window.kwNativeNavigationSearch = true;
  document.documentElement.setAttribute('data-kw-native-search-ready', '');
  const selector = 'details.kw-search-control';
  const close = (details, restoreFocus = false) => {
    details.open = false;
    if (restoreFocus) details.querySelector('summary').focus();
  };
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches(selector) || !details.open) return;
    document.querySelectorAll(`${selector}[open]`).forEach((other) => {
      if (other !== details) close(other);
    });
    const header = details.closest('header,header-component');
    header?.querySelectorAll('.kwc-mobile-nav[open],.kwp-22[open],.kwp-mobile-nav[open]').forEach((menu) => menu.removeAttribute('open'));
    header?.querySelector('.kw-menu-toggle[aria-expanded="true"]')?.click();
    details.querySelector('input[name="q"]').focus({ preventScroll:true });
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.kw-native-search-close');
    if (button) close(button.closest(selector), true);
    document.querySelectorAll(`${selector}[open]`).forEach((details) => {
      if (!details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector(`${selector}[open]`);
    if (details) { event.preventDefault(); close(details, true); }
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll(`${selector}[open]`).forEach((details) => {
      if (!details.closest('header,header-component')?.contains(event.target)) close(details);
    });
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.kw-native-search-form')) return;
    const input = form.elements.namedItem('q');
    input.value = input.value.trim();
    if (!input.value) { event.preventDefault(); input.focus(); }
  });
})();

